<template>
	<div class="col-sm-6 col-md-4 col-lg-4 my-2 py-2 ">
		<div class="m-1 border border-success rounded shadow-md">
			<h5 class="text-capitalize text-light text-sm bg-success px-1 py-2 rounded text-center">
			{{ title }}
			
			</h5>
			<p
				:class="` px-1 py-2 text-center text-dark  ${
					title === 'Email Address'
						? ''
						: 'text-capitalize'
				}`"
			>
				<b>{{dataKey ? dataKey : ''}} {{ text }}</b>
			</p>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "InfoCardComponent",
		props: {
			title: {
				type: String,
				required: true,
			},
			text: {
				type: [String, Number],
				required: true,
			},
			dataKey: {
				type: String,
				default: '',
			},
		},
	};
</script>
